import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { TubularsPanel } from "./TubularsPanel";
import { TubularsFullJob } from "./TubularsFullJob";

/**
 * Tubulars screen — the standalone route. Resolves the current well's active
 * event and renders the assemblies / casing / pipe-tally panel (also embedded
 * in the DDR Tubulars tab).
 */
export function Tubulars() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("tub.title")}</h1>
        <p className="subtitle">
          {well ? `${well.commonName} · ${well.field}` : t("well.notSelected")}
        </p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {well?.uwi ? <TubularsFullJob wellUwi={well.uwi} /> : null}
        {activeEvent ? <TubularsPanel eventId={activeEvent.id} /> : null}
      </QueryState>
    </div>
  );
}
